import axios from "axios";
import React, { useEffect, useState } from "react";
import FormatDate from "../../formatdatetime";
import Pagination from "../../pagination";
import { baseurl } from "../../constant";
import Loading from "../../loading";
const Payoutreport = () => {
  const [data, setdata] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalrecord, settotalrecord] = useState();
  const [loading, setloading] = useState(false);
  const [startdate, setstartdate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [enddate, setenddate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [keyword, setkeyword] = useState();
  const [status, setstatus] = useState();
  const [err, seterr] = useState();
  const [datalength, setdatalength] = useState();

  const viewall = async () => {
    setstartdate(new Date().toLocaleDateString("en-CA"));
    setenddate(new Date().toLocaleDateString("en-CA"));
    setkeyword("");
    setstatus("");
    getdata();
  };

  const token = localStorage.getItem("authToken");
  const pageRecord = 50;
  const totalPage = Math.ceil(totalrecord / pageRecord);
  // const SerialNumber = (currentPage - 1) * pageRecord + index;

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Pagination(totalPage, currentPage);

  var pages = [];
  const maxvisablepage = 8;
  if (totalPage <= maxvisablepage) {
    for (let i = 1; i <= totalPage; i++) {
      pages.push(i);
    }
  } else {
    if (currentPage <= 3) {
      // Show first 3 pages, then ellipsis, then last page
      pages.push(1, 2, 3, ".......", totalPage);
    } else if (currentPage >= totalPage - 2) {
      // Show first page, then ellipsis, then last 3 pages
      pages.push(1, totalPage - 2, totalPage - 1, totalPage);
    } else {
      // Show first page, ellipsis, current page & its neighbors, ellipsis, last page
      pages.push(1, currentPage - 1, currentPage, currentPage + 1, totalPage);
    }
  }

  const getdata1 = async () => {
    try {
      setloading(true);
      const result = await axios.post(baseurl + "payoutReportAuth", {
        token: token,
        pageno: currentPage,
        pageRecord: pageRecord,
        fromDate: new Date().toLocaleDateString("en-CA"),
        toDate: new Date().toLocaleDateString("en-CA"),
        keyword: keyword,
        status: status,
      });

      await setdata(result.data);
      await settotalrecord(result.data.totalRecord);

      setloading(false);
    } catch (err) {
      seterr(err);
    }
  };

  const getdata = async () => {
    try {
      setloading(true);
      const result = await axios.post(baseurl + "payoutReportAuth", {
        token: token,
        pageno: currentPage,
        pageRecord: pageRecord,
        fromDate: startdate,
        toDate: enddate,
        keyword: keyword,
        status: status,
      });

      await setdata(result.data);
      await settotalrecord(result.data.totalRecord);
      setdatalength(result.data.data.length);
      setloading(false);
    } catch (err) {
      seterr(err);
    }
  };
  useEffect(() => {
    getdata();
  }, [currentPage]);

  return (
    <>
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <div className="row">
              <div className="col-sm-12">
                <h4>
                  <b> Payout Report</b>
                </h4>
              </div>

              <div className="col-sm-2">
                <select
                  className="form-control"
                  value={status}
                  onChange={(e) => {
                    setstatus(e.target.value);
                  }}
                >
                  <option value="0">All Status</option>
                  <option value="2">Pending</option>
                  <option value="3">Success</option>
                  <option value="4">Failed</option>
                </select>
              </div>

              <div className="col-sm-2">
                <input
                  type="date"
                  className="form-control datepick"
                  placeholder={startdate}
                  autocomplete="off"
                  name="from_date"
                  id="from_date"
                  value={startdate}
                  onChange={(e) => {
                    setstartdate(e.target.value);
                  }}
                />
              </div>

              <div className="col-sm-2">
                <input
                  type="date"
                  className="form-control datepick"
                  placeholder={enddate}
                  autocomplete="off"
                  name="to_date"
                  id="to_date"
                  value={enddate}
                  onChange={(e) => {
                    setenddate(e.target.value);
                  }}
                />
              </div>
              <div className="col-sm-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Keyword"
                  name="keyword"
                  id="keyword"
                  value={keyword}
                  onChange={(e) => {
                    setkeyword(e.target.value);
                  }}
                />
              </div>
              <div className="col-sm-4">
                <button
                  type="button"
                  className="btn btn-success"
                  id="payoutSearchBtn"
                  onClick={() => getdata()}
                >
                  Search
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    viewall();
                  }}
                >
                  View All
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table
                className="table table-bordered table-striped"
                id="payoutTransferDataTable"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>memberID</th>
                    <th>Name</th>
                    <th>Account</th>
                    <th>Amount</th>
                    <th>Txn Type</th>
                    <th>Txn ID</th>
                    <th>RRN</th>
                    <th>Status</th>
                    <th>Message</th>
                    <th>Date Time</th>
                  </tr>
                </thead>
                <tbody>
                  {datalength > 0 ? (
                    data.data.map((item, index) => (
                      <tr>
                        <td>{(currentPage - 1) * pageRecord + index + 1}</td>
                        <td>{item.memberID}</td>
                        <td>{item.account_holder_name}</td>
                        <td>{item.account_no}</td>
                        <td>{item.transfer_amount}</td>
                        <td>{item.txnType}</td>
                        <td>{item.transaction_id}</td>
                        <td>{item.rrn}</td>
                        {(item.status == 4 || item.status == 0) && (
                          <td style={{ color: "red" }}>Failed</td>
                        )}
                        {item.status == 2 && (
                          <td style={{ color: "orange" }}>Pending</td>
                        )}
                        {item.status == 3 && (
                          <td style={{ color: "green" }}>Success</td>
                        )}
                        <td>mesage</td>
                        <td>{FormatDate(item.created)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <th colspan="11" style={{ textAlign: "center" }}>
                        There is no data in table
                      </th>
                    </tr>
                  )}
                </tbody>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>memberID</th>
                    <th>Name</th>
                    <th>Account</th>
                    <th>Amount</th>
                    <th>Txn Type</th>
                    <th>Txn ID</th>
                    <th>RRN</th>
                    <th>Status</th>
                    <th>Message</th>
                    <th>Date Time</th>
                  </tr>
                </thead>
              </table>

              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage == 1}
                style={{
                  padding: "10px 15px",
                  margin: "5px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                previous
              </button>
              {pages.map((page, index) => (
                <button
                  key={index}
                  onClick={() => page !== "..." && handlePageChange(page)}
                  style={{
                    padding: "10px 15px",
                    margin: "5px",
                    backgroundColor: currentPage === page ? "red" : "#f0f0f0",
                    color: currentPage === page ? "#fff" : "#000",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    cursor: page === "..." ? "default" : "pointer",
                    fontWeight: page === "..." ? "bold" : "normal",
                  }}
                  disabled={page === "..."}
                >
                  {page}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPage || datalength === 0}
                style={{
                  padding: "10px 15px",
                  margin: "5px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Payoutreport;
